import styled, { css } from 'styled-components/macro'
import { switchProp } from 'styled-tools'
import { media, rem } from '../../utils/styles'

const horizontalPosition = switchProp('side', {
  left: css`left: ${rem(36)};`,
  right: css`right: ${rem(36)};`
})

const HeaderAside = styled.div`
  ${media('tablet')`
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    ${horizontalPosition}
  `}
`

export default HeaderAside
